module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-gallery-slideshow js-gallery-slideshow u-absolute u-force-3d u-viewport-fit u-bg--black u-overflow-h",
    class: [_vm.isActive ? 'is-active' : '', _vm.isZoomed ? 'is-zoomed' : ''],
    style: ({
      transform: 'translateY(' + (_vm.$root.scrollTopRealY).toFixed(0) + 'px) translateZ(0)'
    }),
    on: {
      "touchstart": _vm.onTouchDown,
      "touchmove": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd,
      "DOMMouseScroll": _vm.onMouseWheel,
      "mousewheel": _vm.onMouseWheel
    }
  }, [_c('div', {
    staticClass: "u-relative u-force-3d u-flex u-flex-fd--column u-flex-ai--center u-fit"
  }, [_c('div', {
    staticClass: "c-gallery-slideshow__top u-flex u-flex-ai--center u-fit-w"
  }, [_c('div', {
    staticClass: "c-gallery-slideshow__top__back u-inline-block t-text--xxs u-bold u-uppercase u-color--red-pure u-relative u-inline-block u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._hideSlideshow()
      }
    }
  }, [_c('img', {
    staticClass: "c-gallery-slideshow__top__back__arrow u-valign-middle u-marg-r-xs",
    attrs: {
      "src": require("../../../assets/main-menu/arrow-back.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-gallery-slideshow__top__back__text u-inline-block u-valign-middle",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.backToGallery || 'Back to gallery fake')
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-gallery-slideshow__middle u-relative u-fit-w"
  }, _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "c-gallery-slideshow__middle__image-container js-slideshow-image-container u-absolute u-overflow-h u-bg--black",
      class: ['c-gallery-slideshow__middle__image-container--' + index, _vm.activeIndex === index ? 'is-active' : '', _vm.activeIndex <= index - 2 ? 'is-right-right' : '', _vm.activeIndex === index - 1 ? 'is-right' : '', _vm.activeIndex === index + 1 ? 'is-left' : '', _vm.activeIndex >= index + 2 ? 'is-left-left' : '', _vm.activeIndex === index && _vm.isZoomed ? 'is-zoomed' : ''],
      on: {
        "click": function($event) {
          _vm._changeActiveIndexTo(index)
        }
      }
    }, [_c('div', {
      staticClass: "c-gallery-slideshow__middle__image-container__overlay u-absolute u-pos-tl u-index--2 u-fit u-bg--black"
    }), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('img', {
      staticClass: "c-gallery-slideshow__middle__image-container__image js-slideshow-image u-absolute u-index--1 u-fit-w",
      attrs: {
        "src": image.src,
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "c-gallery-slideshow__bottom u-flex u-flex-ai--center u-flex-fd--column@sm u-fit-w"
  }, [_c('div', {
    staticClass: "c-gallery-slideshow__bottom-left u-relative u-flex u-flex-fd--column u-flex-jc--center u-w1of2 u-fit-w@sm"
  }, _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      staticClass: "c-gallery-slideshow__bottom-left__container u-absolute u-pos-tl u-flex u-flex-jc--center u-flex-fd--column u-fit",
      class: [index <= _vm.activeIndex - 1 ? 'is-left' : '', index === _vm.activeIndex ? 'is-active' : '', index >= _vm.activeIndex + 1 ? 'is-right' : '']
    }, [_c('div', {
      staticClass: "u-uppercase u-color--white"
    }, [_vm._v("\n                        " + _vm._s(index + 1) + " "), _c('span', {
      staticClass: "c-gallery-slideshow__bottom-left__separator u-inline-block u-valign-middle u-bg--white"
    }), _vm._v(" " + _vm._s(_vm.images.length) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "u-marg-t-xxxs u-color--white"
    }, [_vm._v("\n                        " + _vm._s(image.title) + "\n                    ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "c-gallery-slideshow__bottom-right u-flex u-flex-ai--center u-flex-jc--end u-flex-jc--start@sm u-w1of2 u-fit-w@sm"
  }, [(_vm.contentPage.share.mail) ? _c('app-btn-share', {
    staticClass: "c-gallery-share-icon",
    attrs: {
      "type": "mail",
      "url": _vm.$root.getPageURLFromID('gallery') + '?s=' + _vm.images[_vm.activeIndex].slug,
      "title": _vm.images[_vm.activeIndex].title,
      "content": _vm.contentPage.share.mail,
      "size": "small"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentPage.share.facebook) ? _c('app-btn-share', {
    staticClass: "c-gallery-share-icon",
    attrs: {
      "type": "facebook",
      "url": _vm.$root.getPageURLFromID('gallery') + '?s=' + _vm.images[_vm.activeIndex].slug,
      "title": _vm.images[_vm.activeIndex].title,
      "content": _vm.contentPage.share.facebook,
      "size": "small"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentPage.share.twitter) ? _c('app-btn-share', {
    staticClass: "c-gallery-share-icon",
    attrs: {
      "type": "twitter",
      "url": _vm.$root.getPageURLFromID('gallery') + '?s=' + _vm.images[_vm.activeIndex].slug,
      "title": _vm.images[_vm.activeIndex].title,
      "content": _vm.contentPage.share.twitter,
      "size": "small"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentPage.share.link) ? _c('app-btn-share', {
    staticClass: "c-gallery-share-icon",
    attrs: {
      "type": "link",
      "url": _vm.$root.getPageURLFromID('gallery') + '?s=' + _vm.images[_vm.activeIndex].slug,
      "title": _vm.images[_vm.activeIndex].title,
      "content": _vm.contentPage.share.link,
      "size": "small"
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-gallery-slideshow__middle__image-container__loader u-absolute u-pos-center u-index--3 u-overflow-h"
  }, [_c('img', {
    staticClass: "c-gallery-slideshow__middle__image-container__loader__img u-absolute u-pos-tl",
    attrs: {
      "src": require("../../../assets/loader/loader-sprite-map.png"),
      "alt": "Loader"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31fa6f78"}!./src/scripts/components/app-gallery-slideshow/template.html
// module id = 901
// module chunks = 0